// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__3MIBV","menu__user-box":"menu_menu__user-box__2RJGT","menu__item":"menu_menu__item__1diwl","menu__icon":"menu_menu__icon__sptDa","active":"menu_active__1Ox1r"};